export const FETCHING_DOC = "FETCHING_DOC";
export const FETCHING_DOC_SUCCESS = "FETCHING_DOC_SUCCESS";
export const FETCHING_DOC_FAILED = "FETCHING_DOC_FAILED";
